export const businessTranslations = {
  BUSINESS_TITLE: 'Business',
  BUSINESS_SUBTITLE: 'Tranzer for your employees',
};
